import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
  //用户添加工程师信息 --周
  getData.engineerRegister= (data)=>{ 
    return http.post(baseUrl+"/engineer/engineer_register/",data)
  }
  //获取工程师注册信息 -- 周
  getData.getEngineerInfo = (data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_register1/"+data+"/")
  }
  //更改工程师注册信息 -- 周
  getData.updateEngineerInfo = (pk,data)=>{ 
    return http.post(baseUrl+"/engineer/engineer_update/"+pk+"/",data)
  }
  //获取全部工程师信息 -- 周
  getData.getAllEngineerInfo = (data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_register/",{ params:data })
  }
  //工程师通过 -- 周
  getData.adoptVerify = (pk,data)=>{ 
    return http.put(baseUrl+"/engineer/engineer_verify/"+pk+"/",data)
  }
  //工程师不通过 -- 周
  getData.NoVerify = (pk,data)=>{ 
    return http.put(baseUrl+"/engineer/engineer_verify_false/"+pk+"/",data)
  }
  //添加项目，添加工单 -- 周
  getData.addworksheetEng = (data)=>{ 
    return http.post(baseUrl+"/one/addworksheet/",data)
  }
  //按照标签查看工单（项目） -- 周 （加不加斜杠后）
  getData.selectWorksheetTips = (data)=>{ 
    return http.post(baseUrl+"/one/select_worksheet_ac_tips/",data)
  }
  //查看全部工单列表,需后台工作人员身份 或者工程师 -- 周
  getData.SALLviewworksheets = (data)=>{
    return http.post(baseUrl+"/one/viewworksheets/",data)
  }
  //查看工单详情&&编辑工单，需要后台人员操作 -- 周
  getData.geteditworksheet = (data)=>{ 
    return http.get(baseUrl+"/one/editworksheet/",{ params:data })
  }
  //查看我的工单列表,需后台工作人员身份或者是工程师 -- 周
  getData.Engviewmyworksheets = (data)=>{ 
    return http.get(baseUrl+"/one/viewmyworksheets/",{ params:data })
  }
  //查看投标列表 -- 周
  getData.viewBidingList = (data)=>{ 
    return http.get(baseUrl+"/one/ac_ws_select_bidding/",{ params:data })
  }
  //查看中标书的详细信息 -- 周
  getData.getWinBiding = (data)=>{ 
    return http.get(baseUrl+"/engineer/select_win_the_bidding/",{ params:data })
  }
  //搜索工单表进行展示 -- 周
  getData.seachMuchWork = (data)=>{ 
    return http.get(baseUrl+"/one/much_select_worksheet/",{ params:data })
  }
  //工程师前台接口--------投递标书 -- 周
  getData.engineerGetWorksheet = (data)=>{ 
    return http.post(baseUrl+"/engineer/engineer_get_worksheet/",data)
  }
  //判断工程师是否对当前标书投标 -- 周
  getData.engineerIsBidding = (data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_is_bidding/",{ params:data })
  }
  //中标-落标 接口 -- 周
  getData.modifyBiddingDocuments = (data)=>{ 
    return http.post(baseUrl+"/engineer/modify_bidding_documents/",data)
  }
  //单个投标书的详情 -- 周
  getData.engselectBidding = (data)=>{ 
    return http.get(baseUrl+"/engineer/select_bidding/",{ params:data })
  }
  //工程师前台上传解决方案 -- 周
  getData.uploadBidFiles = (data)=>{ 
    return http.post(baseUrl+"/engineer/upload_bid_files/",data)
  }
  //获取投标人的详细信息 -- 周
  getData.getEngineerBidInfo = (data)=>{ 
    return http.get(baseUrl+"/engineer/select_worksheet_engineer/",{ params:data })
  }
  //对于方案通过的标书判断是否中标 -- 周
  getData.getBidIsSuccess = (data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_is_success/",{ params:data })
  }
  //工程师选择参与工单的角色 -- 张
  getData.chooseBiddingRole = (data)=>{ 
    return http.post(baseUrl+"/engineer/choose_bidding_role/",data)
  }
  //后台设置施工的起止时间  -- 张
  getData.startEndTime = (pk,data)=>{ 
    return http.post(baseUrl+"/engineer/start_end_time/"+pk+"/",data)
  }
  //后台对项目进行评价  -- 张
  getData.biddingEvaluation = (pk,data)=>{ 
    return http.patch(baseUrl+"/engineer/bidding_evaluation/"+pk+"/",data)
  }
  //工程师个人信息评分 -- 张
  getData.engineerEvaluationInfo = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_evaluation_info/"+pk+"/",{ params:data })
  }
  //三个评价（方案评价-施工评价-顾问评价） -- 张
  getData.engineerEvaluationlist = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_evaluation_list/"+pk+"/",{ params:data })
  }
  //工程师详情页-（工程师基本信息） -- 张
  getData.engineerinformation = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_info/"+pk+"/",{ params:data })
  }
  //工程师详情页-（工程师基本信息）上传头像 -- 张
  getData.engineerinfoP = (pk,data)=>{ 
    return http.post(baseUrl+"/engineer/engineer_info/"+pk+"/",data)
  }
  //条件查询工程师列表 -- 张  
  getData.engineersearchAll = (data)=>{ 
    return http.get(baseUrl+"/engineer/engineers/",{ params:data })
  }
  //工程师前台页面取消投标 -- 张
  getData.deleteBidDoc = (pk)=>{ 
    return http.delete(baseUrl+"/engineer/biddoc/"+pk+"/")
  }
  //关闭工程师模块成功后第一次进入的弹窗 -- 张
  getData.biddocOver = (pk,data)=>{ 
    return http.patch(baseUrl+"/engineer/biddoc_over/"+pk+"/",data)
  }
  //身份证认证填写 -- 张
  getData.engineerAuthPatch = (pk,data)=>{ 
    return http.patch(baseUrl+"/engineer/engineer_auth/"+pk+"/",data)
  }
  //身份证认证获取 -- 张  
  getData.engineerAuthGet = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_auth/"+pk+"/",{ params:data })
  }
  //支付宝信息填写 -- 张
  getData.engineeraliAuthPatch = (pk,data)=>{ 
    return http.patch(baseUrl+"/engineer/engineer_ali_auth/"+pk+"/",data)
  }
  //支付宝信息获取 -- 张  
  getData.engineeraliAuthGet = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_ali_auth/"+pk+"/",{ params:data })
  }
  //获取银行卡列表 -- 张  ?owner=1
  getData.engineerbankAuthGetList = (data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_bank_auth/",{ params:data })
  }
  //创建工程师的银行卡 -- 张{"phone": "17669450133","card_owner": "wang","vcode":"534555","card_num": "231654645","bank":"中国银行","owner":1}
  getData.engineerbankAuthPost = (data)=>{ 
    return http.post(baseUrl+"/engineer/engineer_bank_auth/",data)
  }
  //获取开户行 -- 张
  getData.engineerbankcheckPost = (data)=>{ 
    return http.post(baseUrl+"/engineer/bank_check/",data)
  }
  //获取单个银行卡信息 -- 张 
  getData.engineerNankItemGet = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/engineer_bank/"+pk+"/",{ params:data })
  }
  //删除单个银行卡信息 -- 张
  getData.engineerNankItemDelete = (pk)=>{ 
    return http.delete(baseUrl+"/engineer/engineer_bank/"+pk+"/")
  }
  //获取三个总金额 -- 张 传：login_user_id   返回 amount:总额  amount_can:可提现额  amount_can_not:冻结额
  getData.engineerMoneyAmount = (data)=>{ 
    return http.post(baseUrl+"/engineer/amount/",data)
  }
  //银行卡提现 -- 张  {"who": 1,"card_num":9,"amount":200}phone  vcode
  getData.engineerbankWithdrawMoney = (data)=>{ 
    return http.post(baseUrl+"/engineer/bank_withdraw/",data)
  }
  //支付宝提现 -- 张  {"who": 1,"amount":200}phone  vcode
  getData.EbankAliWithdrawMoney = (data)=>{ 
    return http.post(baseUrl+"/engineer/ali_withdraw/",data)
  }
  //获取冻结列表 -- 张 
  getData.EAmountCanNot = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/amounts/"+pk+"/not/",{ params:data })
  }
  //获取收入列表 -- 张 
  getData.EAmountCanIn = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/amounts/"+pk+"/in/",{ params:data })
  }
  //提现列表 -- 张 
  getData.Etrades = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/trades/"+pk+"/",{ params:data })
  }
  //提现详情单个 -- 张 
  getData.tradeGetItem = (pk,data)=>{ 
    return http.get(baseUrl+"/engineer/trade0/"+pk+"/",{ params:data })
  }
  //修改提现状态 -- 张 
  getData.tradePatchItem = (pk,data)=>{ 
    return http.patch(baseUrl+"/engineer/trade1/"+pk+"/",data)
  }
export default getData


// WEBPACK FOOTER //
// ./src/common/engineer.js